import React from "react";
import { toast } from "react-toastify";
import Popup from "reactjs-popup";
import { Form } from "tabler-react";
import { changeLanguage } from "../language/index";
import clientService from "../services/client";

class StartChatPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contactNumber: "",
      name: "",
      submitting: false,
    };
    this.closeModal = this.closeModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
  }

  closeModal() {
    this.setState({
      contactNumber: "",
      name: "",
      submitting: false,
    });
    this.props.onChange(false);
  }

  handleFieldChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  async handleSubmit(event) {
    event.preventDefault();
    const { contactNumber, name } = this.state;

    if (!contactNumber.trim()) {
      toast.error("Please enter contact number.");
      return;
    }

    if (!/^\d+$/.test(contactNumber.trim())) {
      toast.error("Contact number must be numeric.");
      return;
    }

    this.setState({ submitting: true });
    try {
      const response = await clientService.startChat({
        phoneNumber: contactNumber.trim(),
        name: name.trim(),
      });

      if (response.data && response.data.status === "connected") {
        toast.success("Chat started successfully.");
        if (this.props.onSuccess) {
          this.props.onSuccess(response.data);
        }
        this.closeModal();
      } else if (response.data && response.data.status === "template_sent") {
        toast.info(
          response.data.message ||
            "Template sent. Chat will connect when customer replies.",
        );
        if (this.props.onSuccess) {
          this.props.onSuccess(response.data);
        }
        this.closeModal();
      } else {
        toast.success("Request submitted.");
        this.closeModal();
      }
    } catch (error) {
      const message =
        (error &&
          error.response &&
          error.response.data &&
          error.response.data.message) ||
        "Failed to start chat.";
      toast.error(message);
      this.setState({ submitting: false });
    }
  }

  render() {
    const open =
      this.props.openStartChatPopup && this.props.openStartChatPopup.open;
    const siteLanguage = this.props.siteLanguage;

    return (
      <Popup open={open} onClose={this.closeModal} closeOnDocumentClick>
        <div className="card">
          <div className="card-header">
            <div className="card-options">
              <a
                className="card-options-remove cursorPointer"
                onClick={this.closeModal}
              >
                <i className="fe fe-x" />
              </a>
            </div>
          </div>
          <div className="card-body">
            <h6>Start Chat</h6>
            <form onSubmit={this.handleSubmit}>
              <Form.Group label="Phone number with country code(Ex: 973XXXXXXX)">
                <Form.Input
                  name="contactNumber"
                  value={this.state.contactNumber}
                  onChange={this.handleFieldChange}
                />
              </Form.Group>
              <Form.Group label="Name (optional)">
                <Form.Input
                  name="name"
                  value={this.state.name}
                  onChange={this.handleFieldChange}
                />
              </Form.Group>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={this.state.submitting}
              >
                {this.state.submitting ? "Starting..." : "Start Chat"}
              </button>
            </form>
          </div>
        </div>
      </Popup>
    );
  }
}

export default StartChatPopup;
